import React from 'react';

import { TrendingIcon } from '@change/ds-icons';

import { useI18n } from '@change-corgi/core-react/i18n';
import { ClientRender } from '@change-corgi/core-react/ssr/render';

import { InfoSection, type InfoSectionConnector } from '../InfoSection';
import { StaticSupportCards } from '../StaticSupportCards';

const SIGNATURES_COUNT = 500000;

export const VoiceHeardSection: React.FC<Props> = ({ className, signaturesOnly, connector, newsLogoAltMode }) => {
	const { translate, localizeNumber } = useI18n();

	return (
		<InfoSection
			className={className}
			connector={connector}
			icon={
				<TrendingIcon
					size="medium"
					aria-label={translate('corgi.start_a_petition.chat_app_entry.get_voice_heard_section.voices_heard_alt')}
				/>
			}
			title={translate('corgi.start_a_petition.chat_app_entry.get_voice_heard_section.title')}
			subtitle={translate('corgi.start_a_petition.chat_app_entry.get_voice_heard_section.subtitle')}
			badge={
				<ClientRender
					placeholder={translate('corgi.start_a_petition.chat_app_entry.get_voice_heard_section.signatures_badge', {
						count: String(SIGNATURES_COUNT),
					})}
				>
					{() =>
						translate('corgi.start_a_petition.chat_app_entry.get_voice_heard_section.signatures_badge', {
							count: localizeNumber(SIGNATURES_COUNT),
						})
					}
				</ClientRender>
			}
		>
			<StaticSupportCards signaturesOnly={signaturesOnly} newsLogoAltMode={newsLogoAltMode} />
		</InfoSection>
	);
};

type Props = {
	className?: string;
	/** See `StaticSupportCards` — drops the media-mentions and comments cards. */
	signaturesOnly?: boolean;
	connector?: InfoSectionConnector;
	newsLogoAltMode?: 'generic' | 'outlet';
};
